import { render, staticRenderFns } from "./AllStudentsEvaluation.vue?vue&type=template&id=463b755e&scoped=true&"
import script from "./AllStudentsEvaluation.vue?vue&type=script&lang=js&"
export * from "./AllStudentsEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463b755e",
  null
  
)

export default component.exports